import React from 'react';

export default ({ className }) => (
  <svg
    fill='none'
    className={className}
    viewBox='0 0 400 400'
    xmlSpace='preserve'
  >
    <g>
      <path
        d='M156.000 3.781 C 1.721 39.342,-53.263 229.772,58.482 341.518 C 137.715 420.750,262.285 420.750,341.518 341.518 C 420.750 262.285,420.750 137.715,341.518 58.482 C 293.243 10.208,220.794 -11.155,156.000 3.781 M232.819 93.490 C 259.897 100.326,280.000 124.131,280.000 149.360 C 280.000 168.272,274.904 176.679,247.690 202.667 C 227.303 222.134,223.956 226.556,223.976 234.000 L 224.000 242.667 195.629 242.667 L 167.257 242.667 168.871 229.041 C 171.051 210.631,178.258 199.345,201.606 177.777 C 223.202 157.828,226.420 149.086,216.000 138.667 C 203.140 125.807,176.000 139.344,176.000 158.618 C 176.000 169.361,121.817 162.656,120.536 151.755 C 118.151 131.447,149.386 96.175,172.968 92.548 C 187.871 90.255,222.144 90.794,232.819 93.490 M224.000 285.333 L 224.000 312.000 194.667 312.000 L 165.333 312.000 165.333 285.333 L 165.333 258.667 194.667 258.667 L 224.000 258.667 224.000 285.333 '
        stroke='none'
        fill='currentColor'
        fillRule='evenodd'
      ></path>
    </g>
  </svg>
);
